module.exports = __webpack_public_path__ + "static/media/aptoMedicoDesafio.bbb4ce03.pdf";